<div class="w-full checklist-builder">
  <!-- Groups -->
  <div
    cdkDropList
    [cdkDropListData]="currentChecklist().groups"
    (cdkDropListDropped)="dropGroup($event)"
    class="space-y-4 transition-all duration-300">
    @for (group of currentChecklist().groups; track groupIndex; let groupIndex = $index) {
      <div
        cdkDrag
        [cdkDragDisabled]="disabled()"
        class="group border border-gray-200 rounded-3xl p-4 px-5 bg-white transition-all duration-200 ease-out">
        <!-- Drag Preview Template -->
        <div
          *cdkDragPreview
          class="border border-primary-300 rounded-3xl p-4 px-5 bg-white shadow-xl transform rotate-2 scale-105 opacity-95">
          <div class="flex items-center gap-2">
            <ui-icon icon="griddy-drag-indicator" />
            <strong class="font-semibold">{{ group.title || 'Group name' }}</strong>
          </div>
          <div class="mt-2 text-sm text-gray-500">
            {{ group.items.length }} {{ group.items.length === 1 ? 'item' : 'items' }}
          </div>
        </div>

        <!-- Drag Placeholder -->
        <div
          *cdkDragPlaceholder
          class="border-2 border-dashed border-primary-200 rounded-3xl p-4 px-5 bg-primary-50 opacity-50 transition-all duration-200">
          <div class="h-16 flex items-center justify-center text-primary-400 text-sm"> Drop group here </div>
        </div>

        <!-- Drag Handle -->
        <div class="flex items-center justify-between gap-2">
          <div
            cdkDragHandle
            class="cursor-grab active:cursor-grabbing flex items-center gap-2 p-1 -ml-1 rounded-lg transition-all duration-150 pr-2 hover:bg-gray-100">
            <ui-icon icon="griddy-drag-indicator" class="text-gray-900" />
            <strong class="flex font-semibold text-text-primary">Group name</strong>
          </div>
        </div>

        <!-- Group Title -->
        <div class="w-full flex items-center justify-between gap-2 mt-1">
          <mat-form-field subscriptSizing="dynamic" class="flex-1 nopadding">
            <input
              matInput
              type="text"
              #groupTitleInput
              [value]="group.title"
              (input)="updateGroupTitle(groupIndex, $any($event.target).value)"
              (keyup.enter)="addGroup()"
              (keyup.meta.enter)="addItem(groupIndex)"
              [disabled]="disabled()"
              placeholder="e.g., Bedroom" />
          </mat-form-field>

          <!-- Delete Group Button -->
          <ui-button
            class="flex-shrink-0 self-center"
            icon="griddy-trash-alt"
            variant="quaternary"
            [disabled]="disabled()"
            (onClick)="removeGroup(groupIndex)" />
        </div>

        <!-- Items -->
        <div
          cdkDropList
          [cdkDropListData]="group.items"
          (cdkDropListDropped)="dropItem($event, groupIndex)"
          class="space-y-3 mt-3 transition-all duration-200">
          @for (item of group.items; track item.id; let itemIndex = $index) {
            <div
              cdkDrag
              [cdkDragDisabled]="disabled()"
              class="group/item flex items-center gap-2 transition-all duration-150 ease-out rounded-lg">
              <!-- Item Drag Preview -->
              <div
                *cdkDragPreview
                class="flex items-center gap-2 bg-white border border-primary-300 rounded-lg p-3 shadow-lg transform scale-105 opacity-95">
                <ui-icon icon="griddy-drag-indicator" class="text-primary-500" />
                <span class="font-medium">{{ item.content || 'Task item' }}</span>
              </div>

              <!-- Item Drag Placeholder -->
              <div
                *cdkDragPlaceholder
                class="flex items-center gap-2 border-2 border-dashed border-primary-200 rounded-lg p-1 bg-primary-50 opacity-60 transition-all duration-150">
                <div class="h-8 flex-1 flex items-center justify-center text-primary-400 text-sm"> Drop item here </div>
              </div>
              <!-- Item Drag Handle -->
              <ui-button
                cdkDragHandle
                icon="griddy-drag-indicator"
                variant="tertiary"
                class="opacity-60 group-hover/item:opacity-100 hover:!bg-primary-100 hover:!text-primary-600 transition-all duration-150 flex-shrink-0"
                [disabled]="disabled()" />

              <!-- Item Content -->
              <mat-form-field subscriptSizing="dynamic" class="flex-1 nopadding">
                <input
                  matInput
                  type="text"
                  #itemInput
                  [value]="item.content"
                  (input)="updateItemContent(groupIndex, itemIndex, $any($event.target).value)"
                  (keyup.enter)="addItem(groupIndex)"
                  [disabled]="disabled()"
                  placeholder="Enter a task to be completed. e.g., Empty trash bins" />
              </mat-form-field>

              <!-- Delete Item Button -->
              <ui-button
                class="flex-shrink-0 self-center"
                icon="griddy-trash-alt"
                variant="quaternary"
                [disabled]="disabled()"
                (onClick)="removeItem(groupIndex, itemIndex)" />
            </div>
          }

          <!-- Add Item Button -->
          <ui-button
            class="mt-2"
            label="Add item"
            icon="griddy-plus"
            variant="link-gray"
            [disabled]="disabled()"
            (onClick)="addItem(groupIndex)" />
        </div>
      </div>
    }
  </div>

  <!-- Add Group Button -->
  <div class="mt-4 flex justify-center">
    <ui-button
      label="Add group"
      icon="griddy-plus"
      variant="link-gray"
      [disabled]="disabled()"
      (onClick)="addGroup()" />
  </div>
</div>
